exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container {\n  margin: 30px auto; }\n\n.media-object {\n  max-width: 85px; }\n\n.media-body {\n  padding: 10px; }\n  .media-body .col-sm-12 {\n    padding: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/buyer/onebill-payment/onebill-payment.component.scss
// module id = 497
// module chunks = 0